import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-product-langs',
  templateUrl: './product-langs.component.html',
  styleUrls: ['./product-langs.component.css']
})
export class ProductLangsComponent implements OnInit {
    prodId;

    public itemsListProductLanguages: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadProductLanguages() {
        if (!this.prodId) return;

        this.itemsListProductLanguages = await this.datatask.Post(1082, { prod_id: this.prodId });
    }

    private async init() {
        this.loadProductLanguages();
    }

    ngOnInit() {
        this.init();
    }
}
